import LoadingSpinner from '@atlassian/community-library/dist/components/loading-spinner';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useGetLearningObjectsById } from 'src/api/hooks/useGetLearningObjectsById';

import { findNextUpcomingInstanceId } from './utils/sessionResourceHelpers';

export const PublicClassResolver = () => {
  const navigate = useNavigate();
  const { courseId = '' } = useParams();
  const { data: learningObjectData, isLoading, error } = useGetLearningObjectsById(courseId);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    const courseData = learningObjectData?.data?.data?.[0];

    if (error || !courseData) {
      navigate('/not-found', { replace: true });

      return;
    }

    const tags = courseData.attributes?.tags ?? [];

    if (tags.includes('Team-Training')) {
      navigate(`/team-training/${courseId}`, { replace: true });

      return;
    }

    const { instanceId } = courseData.relationships?.enrollment?.data ?? {};

    if (instanceId) {
      navigate(`/class/${courseId}/session/${instanceId}`, { replace: true });

      return;
    }

    const included = learningObjectData?.data?.included || [];
    const nextUpcomingInstanceId = findNextUpcomingInstanceId(included);

    if (nextUpcomingInstanceId) {
      navigate(`/class/${courseId}/session/${nextUpcomingInstanceId}`, { replace: true });

      return;
    }

    navigate('/not-found', { replace: true });
  }, [isLoading, learningObjectData, error, courseId, navigate]);

  // Always show loading - we're always redirecting somewhere
  return <LoadingSpinner />;
};
